import { Flex, Typography } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AccountAccessRoleEnum } from 'src/api/main'
import { useSessionContext } from 'src/hooks'
import { paths } from 'src/router'

import { AuthLink, OrganizationCard } from '../components'
import { useStyles } from '../styles'

const { Title, Text } = Typography

export const Organizations = () => {
  const { user } = useSessionContext()
  const { styles } = useStyles()
  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    if (!user) {
      navigate(paths.auth.login)
    }
  }, [user, navigate])

  return (
    <>
      <Flex orientation="vertical" gap={12}>
        <Title level={1}>{t('welcome_back')}</Title>
        <Text type="secondary">{t('please_select_organization')}</Text>
      </Flex>

      <Flex
        orientation="vertical"
        gap={16}
        align="stretch"
        className={styles.organizationList}
      >
        {(user?.organizations ?? []).map((organization) => (
          <OrganizationCard key={organization.id} organization={organization} />
        ))}

        {user?.account_access?.[0]?.role === AccountAccessRoleEnum.ADMIN && (
          <AuthLink to={paths.workspaces.root}>
            {t('go_to_management_dashboard')}
          </AuthLink>
        )}
      </Flex>
    </>
  )
}
